<template>
  <div
    id="balance"
    data-testid="balance-container"
  />
</template>

<script>
import { env } from '@/store'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import mount from 'balance/App'
import { getMfeInitialPath } from '@/utils/getMfeInitialPath.utils'
import { getMfeOnNavigate } from '@/utils/getMfeOnNavigate.utils'

export default {
  name: 'BalancePage',
  data () {
    return {
      unmountBalanceMfe: null
    }
  },
  computed: {
    ...mapGetters(['accountId', 'merchantId', 'account']),
    balanceEnv () {
      if (this.account?.account_type.value.toLowerCase() === 'test') {
        return 'test'
      }
      return 'live'
    }
  },
  methods: {
    setError (error) {
      this.$store.dispatch('SET_ERROR', error)
    },
    onNavigate (pathname, search) {
      getMfeOnNavigate(this.$route, this.$router, pathname, search)
    },
    onGoBack () {
      this.$router.go(-1)
    }
  },
  async mounted () {
    const envPrefix = env ?? ''
    const token = Cookies.get(`${envPrefix}mp_tk`)

    const domEl = document.getElementById('balance')
    const prefix = this.$router.history?.base ?? ''

    const props = {
      initialPath: getMfeInitialPath(this.$route),
      environment: this.balanceEnv,
      onGoBack: this.onGoBack,
      onNavigate: this.onNavigate,
      routeBaseName: `${prefix}/${this.merchantId}/${this.accountId}`,
      authProps: {
        jwt: token,
        accountId: this.accountId,
        merchantId: this.merchantId,
        onAuthError: error => {
          this.setError(error)
        }
      },
      url: `${process.env.VUE_APP_BALANCE_URL}`
    }

    const { onHostNavigate, unmount } = await mount(domEl, props)
    this.unmountBalanceMfe = unmount

    this.$router.afterEach((to, from) => {
      const { fullPath } = to
      let [pathname, search] = fullPath.split('?')

      const routeRegex = /\/balance$/g
      const matches = fullPath.match(routeRegex)
      const isGoingToBalanceHome = !!matches

      const {
        params: { pg_recipient_id: pgRecipientId }
      } = from

      if (isGoingToBalanceHome && pgRecipientId) {
        pathname += `/${pgRecipientId}`
      }

      onHostNavigate(pathname, search)
    })
  },
  beforeDestroy () {
    if (this.unmountBalanceMfe) {
      this.unmountBalanceMfe()
    }
  }
}
</script>
